// /agents — the /team-and-agents canvas, AGENTS ONLY.
//
// This page IS /team-and-agents (it `extends: 'teamAndAgents'`), so it inherits
// the whole surface verbatim — panzoom, drag-to-rearrange, the agent detail
// modal, layout-prefs persistence, presence pulses. The ONLY differences are:
//   1. `root._canvasAgentsOnly` is flipped ON while mounted — team-and-agents.js
//      then hides every human node (`_visiblePeople` → []), the team swim-lane
//      frames (they derive from the people), and all connections (they'd dangle
//      to a hidden person), and the "+" island drops its "Human" row.
//   2. A filter toolbar (mounted in the Stage, gated on `_canvasAgentsOnly`)
//      drives `root._agents{Scope,Status,Type,Assign}`, which `_visibleAgents`
//      reads. Scope = All agents (default) / My agents; plus Status (active /
//      idle), Type (by agent kind), Assignment (assigned / unassigned).
//
// Layout is intentionally SHARED with /team-and-agents (same `_tagPositions`
// prefs): a given agent sits in the same spot on both canvases.

export const agents = {
  extends: 'teamAndAgents',
  metadata: (el) => ({ title: el.call('pageTitle', 'canvas.page.agents.title') }),
  // This route's own name on the inherited, visually hidden `h1`.
  PageSrTitle: { text: '{{ canvas.page.agents.title | polyglot }}' },

  // The lens (1 above), as data: the inherited onCreate flips agents-only mode
  // ON and seeds the default filters before the boot; the inherited onRemove
  // clears it, so /team-and-agents + the home embed (which share this same
  // root) render the full set again. No hook here: a hook that called the
  // board's own hook through the page OBJECT made frank copy the whole page
  // into globalScope (canvas case 3, 2026-11-01).
  scope: { canvasLens: 'agents' }
}
